import React, { useState } from "react";
import { Button } from "../ui/button";
import { Mail, MessageSquarePlus, Copy, Send } from "lucide-react";
import { toast } from "sonner";

const TONES = [["formale", "Formale"], ["informale", "Informale"], ["breve", "Breve"]];

const copy = (text, label) => {
  navigator.clipboard.writeText(text || "");
  toast.success(`${label} copiato`);
};

export const MessagesTab = ({ p, generating, onGenerate }) => {
  const [tone, setTone] = useState("informale");
  const variants = p.messages?.variants;
  const v = variants?.[tone] || {};

  return (
    <>
      <div className="flex items-center justify-between">
        <p className="text-xs text-muted-foreground">Testi WhatsApp ed email in 3 toni, generati dall'AI dall'audit.</p>
        <Button size="sm" onClick={onGenerate} disabled={generating} data-testid="generate-messages-btn">
          <Send className="mr-2 h-3.5 w-3.5" /> {generating ? "Genero..." : variants ? "Rigenera" : "Genera"}
        </Button>
      </div>
      {!variants && !generating && (
        <div className="rounded-xl border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
          Nessun messaggio ancora. Premi <b>Genera</b> per ottenere WhatsApp ed email in tono formale, informale e breve.
          {!p.ai_analyzed && <div className="mt-2 text-xs">Suggerimento: fai prima l'analisi AI per messaggi più mirati.</div>}
        </div>
      )}
      {variants && (
        <>
          <div className="flex gap-1 rounded-lg border border-border p-1" data-testid="tone-switch">
            {TONES.map(([k, l]) => (
              <button key={k} onClick={() => setTone(k)} data-testid={`tone-${k}`}
                className={`flex-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors ${tone === k ? "bg-primary/15 text-primary" : "text-muted-foreground hover:text-foreground"}`}>
                {l}
              </button>
            ))}
          </div>
          <div className="rounded-xl border border-[#22C55E]/30 bg-[#22C55E]/5 p-4">
            <div className="mb-2 flex items-center justify-between">
              <div className="flex items-center gap-2 label-caps text-[#22C55E]"><MessageSquarePlus className="h-3.5 w-3.5" /> WhatsApp</div>
              <Button size="sm" variant="ghost" onClick={() => copy(v.whatsapp, "WhatsApp")} data-testid="copy-whatsapp-btn"><Copy className="h-3.5 w-3.5" /></Button>
            </div>
            <p className="whitespace-pre-wrap text-sm leading-relaxed" data-testid="msg-whatsapp">{v.whatsapp}</p>
          </div>
          <div className="rounded-xl border border-primary/30 bg-primary/5 p-4">
            <div className="mb-2 flex items-center justify-between">
              <div className="flex items-center gap-2 label-caps text-primary"><Mail className="h-3.5 w-3.5" /> Email</div>
              <Button size="sm" variant="ghost" onClick={() => copy(`${v.email_subject}\n\n${v.email_body}`, "Email")} data-testid="copy-email-btn"><Copy className="h-3.5 w-3.5" /></Button>
            </div>
            <div className="text-sm font-semibold">{v.email_subject}</div>
            <p className="mt-2 whitespace-pre-wrap text-sm leading-relaxed" data-testid="msg-email">{v.email_body}</p>
          </div>
        </>
      )}
    </>
  );
};
